import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 32,
    paddingBottom: 32,
    paddingHorizontal: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: '#111',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  logo: {
    width: 40,
    height: 40,
    marginRight: 14,
  },
  headerText: {
    flexGrow: 1,
    textAlign: 'center',
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 2,
  },
  meta: {
    fontSize: 9,
    marginTop: 3,
    color: '#444',
  },
  section: {
    marginTop: 10,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#d0d0d0',
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 4,
  },
  col: {
    flexGrow: 1,
  },
  fieldLabel: {
    fontSize: 9,
    color: '#555',
    marginBottom: 1,
  },
  fieldValue: {
    fontSize: 10,
  },
  fieldValueMuted: {
    fontSize: 10,
    color: '#777',
  },
  footer: {
    marginTop: 14,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#d0d0d0',
    fontSize: 9,
    color: '#444',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

